export const SEARCHPATH = '/SearchDisplay';
